import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import SignIn from '@/features/auth/sign-in'

const searchSchema = z.object({
  redirect: z.string().optional(),
})

export const Route = createFileRoute('/(auth)/sign-in')({
  validateSearch: searchSchema,
  component: SignIn,
})
